<template>
  <div class="qywhc1 animation srcospcur">
    <div class="cons">
      <div class="zhunrc2_">
        <div class="zhunr2c_s swiper-container-horizontal swiper-container-multirow">
          <Swiper :options="swiperOption" ref="mySwiper">
            <Swiper-slide
              v-for="(item,index) in imgs"
              :key="item.id"
              style="order: 0; width: 222.5px; margin-right: 10px;"
            >
              <a
                style="margin-bottom:10px;"
                href="javascript:;"
                title
                @click="slideClick(item,index,'up')"
              >
                <img :src="item[0].imageUrl" />
              </a>
              <a
                v-if="item.length>1"
                href="javascript:;"
                title
                @click="slideClick(item,index,'down')"
              >
                <img :src="item[1].imageUrl" />
              </a>
            </Swiper-slide>
          </Swiper>

          <div class="swiper-scrollbar" style="transition-duration: 0ms;">
            <div
              class="swiper-scrollbar-drag"
              style="transform: translate3d(0px, 0px, 0px); transition-duration: 0ms; width: 198.764px;"
            ></div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
    </div>
    <el-dialog
      class="my-dialog"
      title
      :visible.sync="dialogVisible"
      width="80%"
      :append-to-body="true"
      :modal-append-to-body="true"
      close-on-click-modal
      close-on-press-escape
      show-close
    >
      <div style="text-align:center" @click="dialogVisible=false">
        <img style="display:inline" :src="clickImgSrc" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      dialogVisible: false,
      clickImgSrc: "",
      imgs: this.$props.data || [],
      swiperOption: {
        autoplay: false,
        loop: false,
        slidesPerView: 4,
        slidesPerColumn: 1,
        // direction: "horizontal",
        slidesPerColumnFill: "row", //column
        spaceBetween: 10,
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        scrollbarDraggable: true,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 8
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 6
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      }
    };
  },
  created() {
    if (this.$props.data.length > 0) {
      let marr = this.resetArr(this.$props.data);
      this.$set(this.$data, "imgs", marr);
    }
  },
  methods: {
    resetArr(arr) {
      let upd = [];
      let downd = [];
      let marr = [];
      for (let i = 0; i < arr.length; i++) {
        if (i % 2 == 0) {
          upd.push(arr[i]);
        } else {
          downd.push(arr[i]);
        }
      }
      for (let i = 0; i < upd.length; i++) {
        let narr = [upd[i]];
        if (i <= downd.length - 1) {
          narr.push(downd[i]);
        }
        marr.push(narr);
      }
      return marr;
    },
    slideClick(item, index, type) {
      let obj = type == "up" ? item[0] : item[1];
      this.clickImgSrc = obj.imageUrl;
      this.dialogVisible = true;
    }
  }
};
</script>
